import Case from "./Case";
import NotCase from "./NotCase";
import Switch from "./Switch";

export default Object.assign(Switch, {
  Case,
  NotCase,
});
